(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["dateformat"] = factory();
	else
		root["dateformat"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setOptions", function() { return setOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "format", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatToDate", function() { return formatToDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDateStart", function() { return getDateStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDateEnd", function() { return getDateEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compareDate", function() { return compareDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLeapYear", function() { return isLeapYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValidDate", function() { return isValidDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addDay", function() { return addDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtractDay", function() { return subtractDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addMonth", function() { return addMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtractMonth", function() { return subtractMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addYear", function() { return addYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtractYear", function() { return subtractYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNotEmpty", function() { return isNotEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDate", function() { return isDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getWeek", function() { return getWeek; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDateDiff", function() { return getDateDiff; });
/**
 * Created by 影浅-seekwe@gmail.com on 2018-01-12
 */

var WEEKTYPE = {
  DAYNAME: 0,
  SDAYNAME: 1
};

var _OPTIONS = {
  default: 'ZH',
  ZH: {
    daysAgo: '天前',
    hoursAgo: '小时前',
    MinutesAgo: '分钟前',
    SecondsAgo: '秒前',
    justNow: '刚刚',
    dayNames: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
    shortDayNames: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
    monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
    shortMonthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
  },
  US: {
    daysAgo: ' Days ago',
    hoursAgo: ' Hours ago',
    MinutesAgo: ' Minutes ago',
    justNow: ' Just now',
    SecondsAgo: ' Seconds ago',
    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    shortDayNames: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    shortMonthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  }
};

var setOptions = function setOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  for (var k in options) {
    _OPTIONS[k] = options[k];
  }
};

var isInt = function isInt(str) {
  return typeof str === 'number';
};
/**
 * 格式化时间
 * @param date
 * @param fmt
 * @returns {*}
 */
var format = function format(date) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd hh:mm:ss';

  date = formatToDate(date);
  var o = {
    'M+': date.getMonth() + 1, //月份
    'd+': date.getDate(), //日
    'h+': date.getHours(), //小时
    'm+': date.getMinutes(), //分
    's+': date.getSeconds(), //秒
    'q+': Math.floor((date.getMonth() + 3) / 3), //季度
    'S': date.getMilliseconds() //毫秒
  };

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
};

/**
 * return Date
 */
var formatToDate = function formatToDate(dateStr) {
  if (!isNotEmpty(dateStr)) {
    throw 'argument format is wrong';
  }
  var date = void 0;
  switch (true) {
    case isDate(dateStr):
      date = dateStr;
      break;
    case isInt(dateStr):
      date = new Date(dateStr);
      break;
    default:
      date = new Date(Date.parse(dateStr.replace(/-/g, '/')));
  }
  return date;
};

var getDateStart = function getDateStart(date) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd hh:mm:ss';

  var datetime = format(date, 'yyyy-MM-dd') + ' 00:00:00';
  return !fmt ? formatToDate(datetime) : format(datetime, fmt);
};

var getDateEnd = function getDateEnd(date) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd hh:mm:ss';

  var datetime = format(date, 'yyyy-MM-dd') + ' 23:59:59';
  return !fmt ? formatToDate(datetime) : format(datetime, fmt);
};

var compareDate = function compareDate(d1, d2) {
  d1 = formatToDate(d1);
  d2 = formatToDate(d2);
  if (d1 && d2) {
    if (d1.getTime() > d2.getTime()) {
      return 1;
    } else if (d1.getTime() === d2.getTime()) {
      return 0;
    } else if (d1.getTime() < d2.getTime()) {
      return -1;
    }
  }
};

/**
 * 是否闰年
 */
var isLeapYear = function isLeapYear(date) {
  date = formatToDate(date);
  return 0 === date.getYear() % 4 && (date.getYear() % 100 !== 0 || date.getYear() % 400 === 0);
};
/**
 * 有否有效日期
 */
var isValidDate = function isValidDate(dateStr) {
  if (isNotEmpty(dateStr)) {
    var r = dateStr.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/);
    if (r === null) {
      return false;
    }
    var d = new Date(r[1], r[3] - 1, r[4]);
    var num = d.getFullYear() === r[1] && d.getMonth() + 1 === r[3] && d.getDate() === r[4];
    return num !== 0;
  }
};

var addDay = function addDay(dayNum) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd hh:mm:ss';
  var date = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date();

  date = formatToDate(date);
  date.setDate(date.getDate() + dayNum);
  return !fmt ? date : format(date, fmt);
};

var subtractDay = function subtractDay(dayNum) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd hh:mm:ss';
  var date = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date();

  date = formatToDate(date);
  date.setDate(date.getDate() - dayNum);
  return !fmt ? date : format(date, fmt);
};

var monthBeforeFormatAndDay = function monthBeforeFormatAndDay(date, day) {
  var mo = date.getMonth() + 1;
  if (mo === 4 || mo === 6 || mo === 9 || mo === 11) {
    if (day >= 30) {
      day = 30;
    }
  } else if (mo === 2) {
    if (isLeapYear(date)) {
      if (day >= 29) {
        day = 29;
      } else {
        day = 28;
      }
    } else if (day >= 28) {
      day = 28;
    }
  } else {
    //大月
    if (day >= 31) {
      day = 31;
    }
  }
  return day;
};

var addMonth = function addMonth(monthNum) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd hh:mm:ss';
  var date = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date();

  date = formatToDate(date);
  var currentDay = date.getDate();
  date.setMonth(date.getMonth() + monthNum, 1);
  var newDay = monthBeforeFormatAndDay(date, currentDay);
  date.setDate(date.getDate() + (newDay - 1));
  return !fmt ? date : format(date, fmt);
};

var subtractMonth = function subtractMonth(monthNum) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd hh:mm:ss';
  var date = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date();

  date = formatToDate(date);
  var currentDay = date.getDate();
  date.setMonth(date.getMonth() - monthNum, 1);
  var newDay = monthBeforeFormatAndDay(date, currentDay);
  date.setDate(date.getDate() + (newDay - 1));
  return !fmt ? date : format(date, fmt);
};

var addYear = function addYear(yearNum) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd hh:mm:ss';
  var date = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date();

  date = formatToDate(date);
  date.setYear(date.getFullYear() + yearNum);
  return !fmt ? date : format(date, fmt);
};

var subtractYear = function subtractYear(yearNum) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd hh:mm:ss';
  var date = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date();

  date = formatToDate(date);
  date.setYear(date.getFullYear() - yearNum);
  return !fmt ? date : format(date, fmt);
};

var isNotEmpty = function isNotEmpty(str) {
  return str !== '' && str != null && typeof str !== 'undefined';
};

var isDate = function isDate(str) {
  return str instanceof Date;
};
var getWeek = function getWeek(date, type) {
  if (date) {
    if (!isNotEmpty(type)) {
      type = 0;
    }
    var index = date.getDay();
    var dateStr = '';
    switch (type) {
      case WEEKTYPE.DAYNAME:
        dateStr = _OPTIONS[_OPTIONS.default].dayNames[index];
        break;
      case WEEKTYPE.SDAYNAME:
        dateStr = _OPTIONS[_OPTIONS.default].shortDayNames[index];
        break;
    }
    return dateStr;
  }
};

var getDateDiff = function getDateDiff(date) {
  if (!isDate(date)) {
    date = formatToDate(date);
  }
  var publishTime = parseInt(date.getTime() / 1000);
  var nowTime = parseInt(new Date().getTime() / 1000);
  var parsec = nowTime - publishTime;
  var parsec_days = parseInt(parsec / 86400);
  var parsec_hours = parseInt(parsec / 3600);
  var parsec_minutes = parseInt(parsec / 60);
  var parsec_seconds = parseInt(parsec);

  if (parsec_days > 0 && parsec_days < 3) {
    return parsec_days + _OPTIONS[_OPTIONS.default].daysAgo;
  } else if (parsec_days <= 0 && parsec_hours > 0) {
    return parsec_hours + _OPTIONS[_OPTIONS.default].hoursAgo;
  } else if (parsec_hours <= 0 && parsec_minutes > 0) {
    return parsec_minutes + _OPTIONS[_OPTIONS.default].MinutesAgo;
  } else if (parsec_seconds < 60) {
    if (parsec_seconds <= 0) {
      return _OPTIONS[_OPTIONS.default].justNow;
    } else {
      return parsec_seconds + _OPTIONS[_OPTIONS.default].SecondsAgo;
    }
  } else if (parsec_days >= 3 && parsec_days < 30) {
    return subtractDay(parsec_days, 'MM-dd hh:mm:ss');
  } else if (parsec_days >= 30) {
    return format(subtractDay(parsec_days), 'yyyy-MM-dd hh:mm:ss');
  }
};
/* harmony default export */ __webpack_exports__["default"] = (format);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// dateformat.js